import {
  PackingVolume,
  PackingWeight,
  State,
} from "@/model/HenganLoadingPlanModels";
import { ProductInfoByPack } from "@/views/warehouse-management/HenganLoadingPlanDetailForWarehouse.vue";

export class ProductSummation {
  totalAmountSummation: number;
  productStatistics: ProductStatistics[];
}

export class ProductStatistics {
  totalNumber: number;
  customsPackingTotalNumber: number;
  secondaryPackingTotalNumber: number;
  totalNetWeight: number;
  totalAmount: number;
}

export class CustomsPackingSummation {
  pltSummationNumber: number;
  ctnSummationNumber: number;
  customsPackingSummationNumber: number;
  secondaryPackingSummationNumber: number;
  productSummationNumber: number;
  summationGrossWeight: number;
  summationNetWeight: number;
  summationVolume: number;
  customsPackingStatistics: CustomsPackingStatistics[];
}

export class CustomsPackingStatistics {
  customsPackingCode: string;
  secondaryTotalNumber: string;
  grossWeight: number;
  netWeight: number;
  productTotalNumber: number;
  volume: number;
}

export class HqPackingListDetail {
  id: string;
  code: string;
  deliveryNoteId: string;
  deliveryNoteCode: string;
  factoryName: string;
  shippingMark: string;
  remark: string;
  moneyList: Money[];
  customsPackingSet: CustomsPacking[];
  productInfos: ProductInfo[];

}

export class Money {
  type:{type: string,desc:string};
  value: number;
  remark: string;
  deduction: boolean;
}

export class CustomsPacking {
  id: string;
  code: CustomsPackingCode;
  ackTypeDesc: string;
  stateDesc: string;
  ackType: string;
  state: State;
  number: string;
  grossWeight: number;
  netWeight: number;
  length: number;
  width: number;
  height: number;
  groupId: string;
  confirmedStateDesc: string;
  problemType?: string;
  loadingFirst?: boolean;
  bePackagedCustomsPacking: boolean;
  secondaryPackingSet: SecondaryPacking[];

  storageLayerName?: string;

  inventory: string;
  useInventoryQuantity: number;
  exception:boolean;
  exceptionReason:CustomsPackingProblemType;

  public completeCode(): string {
    return (
      this.code.typeCode + this.code.selfCode + "#" + this.code.serialNumber
    );
  }
}

export class CustomsPackingGroup {
  id: string;
  code: CustomsPackingCode;
  checked: boolean;
  name: string;
}

export class SecondaryPacking {
  id: string;
  cartonNumber: number;
  packingInfos: SecondaryPackingInfo[];
  // productInfos: ProductInfo[];
}

export class SecondaryPackingInfo {
  id: string;
  secondaryPackingId: string;
  packingVolume: PackingVolume;
  packingWeight: PackingWeight;
  productInfos: ProductInfo[];
  /**
   * 次包装箱数
   */
  cartonNumber: number;
}

export class ProductInfo {
  id: string;
  description: string;
  declarationDescription: string;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  hqTransactionNumber: string;
  totalNumberPcs: number;
  netWeight: number;
  purchaseOrderNumber: string;
  batch: string;
  unitPrice: number;
  poNumber: string;
  remark: string;
  parentId: string;
  loadingFirst?: boolean;
  containerNumber?: string;
}

export class BulkProductTableRowData {
  id: string;
  description: string;
  declarationDescription: string;
  guestModel: string;
  hqOrJrNumber: string;
  oeNumber: string;
  refNumber: string;
  totalNumberPcs: number;
  netWeight: number;
  purchaseOrderNumber: string;
  batch: string;
  unitPrice: number;
  poNumber: string;
  remark: string;
  parentId: string;
  isEdit: boolean;
  popoverVisible: boolean;
}

export class TableRowData {
  //产品属性
  productId: string;
  productName: string;
  customsName: string;
  customerModel: string;
  hAndQNumber: string;
  oeNumber: string;
  refNumber: string;
  hqTransactionNumber: string;
  totalPcs: number;
  originTotalPcs: number;
  purchaseOrderNumber: string;
  batch: string;
  unitPrice: number;
  poNumber: string;
  remark: string;

  // 次包装属性
  secondaryPackingId: string;
  ctnQuantity: number;
  originCtnQuantity: number;
  cntWeight: number;
  ctnGrossWeight: number;
  ctnLength: number;
  ctnWidth: number;
  ctnHeight: number;

  // 主包装属性
  customsPackingId: string;
  grossWeight: number;
  netWeight: number;
  length: number;
  width: number;
  height: number;
  code: CustomsPackingCode;
  groupId: string;
  state: string;
  customsPackingState: string;
  ackType: string;
  problemType?: string;
  confirmedStateDesc: string;
  loadingFirst?: boolean;
  bePackagedCustomsPacking: boolean;
  exception:boolean;
  exceptionReason:CustomsPackingProblemType;

  secondaryPackingRows: number;
  secondaryPackingOptionalInfoRows: number;
  customsPackingRows: number;
  optionalPopoverVisible: boolean;
  showPopover: boolean;
  id: string;
  customsPackingGroups: CustomsPackingGroup[];

  // action
  // 是否在编辑中
  isEdit: boolean;
  indeterminate: boolean;
  hasChildren: boolean;
  isCheck: boolean;
  // 吃包装数量是否在编辑中
  isSecondaryPackingEdit: boolean;
  popoverVisible: boolean;

  inventory: string;
  useInventoryQuantity: number;
  containerNumber: string;

  storageLayerName?: string;
}

export class CustomsPackingCode {
  typeCode: string;
  selfCode: string;
  serialNumber: string;

  format(): string {
    return this.typeCode + this.selfCode + "#" + this.serialNumber;
  }
}

export class PackCustomsPackingInput {
  type: string;
  customsPackingCode: string;
  grossWeight: number;
  netWeight: number;
  length: number;
  width: number;
  height: number;
  productInfos: ProductInfoByPack[];
  customsPackingIds: string[];
  containerNumber: string;

  constructor() {
    this.type = "PLT";
    this.productInfos = [];
    this.customsPackingIds = [];
  }
}

export class HqPackingListAggregateInfo {
  hqPackingList: HqPackingListDetail;
  customsPackingSummation: CustomsPackingSummation;
  productSummation: ProductSummation;
}

export class HqPackingListHistory {
  code: CustomsPackingCode;
  createdAt: string;
  grossWeight: number;
  height: number;
  id: string;
  length: number;
  netWeight: number;
  problemType: string;
  secondaryPackingSet: SecondaryPackingSet[];
  width: number;
}
export class SecondaryPackingSet {
  id: string;
  cartonNumber: number;
  infos: Infos[];
}
export class Infos {
  grossWeightPerCarton: number;
  height: number;
  length: number;
  netWeight: number;
  width: number;
  productInfos: ProductInfo[];
}

export class InventoryList {
  id: string;
  serialNumber: number;
  hqPackingListCode: string;
  sideMarkProductModel: string;
  sideMarkProductQuantity: string;
  sideMarkProductTotalQuantity: number;
}
export class CustomsPackingProblemType {
    name: string;
    value: string;
}
